/**
 * Replaces asterisks in brackets [*] with provided icon images
 * @param {string|Object} input - Either a string or data object with text property
 * @param {string} icon - The icon URL to show instead of asterisks
 * @returns {string|Object} - Same type as input with asterisks replaced by icons
 */
export const showStarsInsteadOfAsterisks = (input, icon) => {
  // Type checking and validation
  if (!input) return input
  if (!icon || typeof icon !== "string") return input

  // Determine if input is string or object
  const isString = typeof input === "string"
  const text = isString ? input : input?.text

  // If no text to process, return original input
  if (!text || typeof text !== "string") return input

  // Replace asterisks with icon images
  const processedText = text.replace(/\[(\*+)\]/g, (match, asterisks) => {
    // Create multiple img tags for each asterisk
    const starIcons = asterisks
      .split("")
      .map(() => `<img src="${icon}" alt="" width="13" height="13" />`)
      .join("")

    const altText = asterisks.length === 1 ? "star icon" : `${asterisks.length} out of 5 stars`
    return `<span alt="${altText}">${starIcons}</span>`
  })

  // Return same type as input
  return isString ? processedText : { ...input, text: processedText }
}
